export type PenaltyRaw = Omit<Penalty, 'time'> & { time: number };

export class Penalty {
  text!: string;
  time!: Date;

  constructor(obj: PenaltyRaw) {
    this.update(obj);
  }

  update(obj: PenaltyRaw) {
    this.text = obj.text;
    if (obj.time > 0) {
      this.time = new Date(obj.time);
    }
  }
}
